export default __webpack_public_path__ + "static/media/pix.79a319f6.svg";